import AlertCircleIcon from "@redotech/redo-icons/alert-circle.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoIcon } from "@redotech/redo-web/arbiter-components/icon/redo-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useNavigate } from "react-router-dom";
import type { BlockedResult } from "./types";

export const BlockedNotice = memo(function BlockedNotice({
  block,
}: {
  block: BlockedResult;
}) {
  const navigate = useNavigate();
  const action = block.action;

  return (
    <Flex
      align="center"
      bgColor="secondary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      gap="md"
      justify="space-between"
      p="md"
      radius="sm"
    >
      <Flex align="center" gap="sm" grow={1} minW="none">
        <RedoIcon color="warning" Icon={AlertCircleIcon} size={16} />
        <Text fontSize="sm" textColor="secondary">
          {block.message}
        </Text>
      </Flex>
      {action && (
        <RedoButton
          hierarchy="secondary"
          onClick={() => navigate(action.href)}
          size="sm"
          text={action.label}
        />
      )}
    </Flex>
  );
});
